import { useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Bold, List, ListOrdered, Pilcrow } from "lucide-react";

export function RichTextEditor({ value, onChange, testid }) {
  const ref = useRef(null);
  const hydrated = useRef(false);

  useEffect(() => {
    if (hydrated.current || !ref.current) return;
    const clean = DOMPurify.sanitize(value || "");
    if (clean) {
      ref.current.innerHTML = clean;
      hydrated.current = true;
    }
  }, [value]);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current.innerHTML);
  };

  const Btn = ({ cmd, arg, icon: Icon, label }) => (
    <button
      type="button"
      title={label}
      onMouseDown={(e) => { e.preventDefault(); exec(cmd, arg); }}
      className="rounded-md p-2 text-slate-600 hover:bg-slate-100"
    >
      <Icon size={16} />
    </button>
  );

  return (
    <div className="overflow-hidden rounded-lg border border-slate-300 bg-white">
      <div className="flex gap-1 border-b border-slate-200 bg-slate-50 p-1.5">
        <Btn cmd="bold" icon={Bold} label="Bold" />
        <Btn cmd="formatBlock" arg="<p>" icon={Pilcrow} label="Paragraph" />
        <Btn cmd="insertUnorderedList" icon={List} label="Bullet list" />
        <Btn cmd="insertOrderedList" icon={ListOrdered} label="Numbered list" />
      </div>
      <div
        ref={ref}
        data-testid={testid}
        contentEditable
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        data-placeholder="Enter machine description..."
        className="editor-content rich-text min-h-[140px] px-4 py-3 text-sm text-slate-700"
      />
    </div>
  );
}
